import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from 'components/App';
import { ThemeProvider } from 'styled-components';
import { theme } from 'components/theme.jsx';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      {/* для гита нужно с basename */}
      <BrowserRouter basename="/goit-react-hw-05-movies/">
        {/* <BrowserRouter> */}
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
